import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Text = styled.p<{theme: Theme}>`
  font-weight: normal;
  font-size: 14px;
  color: ${({theme}) => theme.secondary};
  padding: 0 10px;
`;
